module.exports = __webpack_public_path__ + "img/book(8).43676202.png";